var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 33,
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.99,
    cy: 16.86,
    r: 14.01,
    fill: "#28414b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 33a16 16 0 1116-16 16 16 0 01-16 16zm5.4-22.49a1.19 1.19 0 101.18 1.18 1.18 1.18 0 00-1.18-1.18zM17.13 12a5 5 0 105 5 5 5 0 00-5-5zm0 8.16A3.19 3.19 0 1120.32 17a3.18 3.18 0 01-3.19 3.19zm10-7.32A6.07 6.07 0 0021.1 6.8h-8A6.06 6.06 0 007 12.87v8a6.06 6.06 0 006.06 6.07h8a6.07 6.07 0 006.07-6.07zm-1.9 8A4.17 4.17 0 0121.1 25h-8a4.17 4.17 0 01-4.16-4.17v-8a4.17 4.17 0 014.15-4.13h8a4.17 4.17 0 014.17 4.17z",
    fill: "#ffc212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.434f4d53d592b7f9fd47d9fb7b2d059a.svg";
export { ForwardRef as ReactComponent };